/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createErf } from '../../factoriesAny.js';
export var erfDependencies = {
  typedDependencies,
  createErf
};